<script setup>
import ArticlesCarousel from "~/components/organisms/ArticlesCarousel.vue";

const props = defineProps({
  data: Object,
  settings: Object,
})

const { t } = useI18n()

const articles = computed(() => props.data?.articles || [])

const title = computed(() => props.settings?.title || t('blog.related_articles') || 'Relaterade artiklar')
</script>

<template>
  <ArticlesCarousel
    v-if="articles.length"
    :articles="articles"
    :title="title"
  />
</template>
